import React from 'react';
import Hero from '../components/Hero';
import ServicesPreview from '../components/ServicesPreview';
import PartnerCarousel from '../components/PartnerCarousel';
import Testimonials from '../components/Testimonials';
import TrustSignals from '../components/TrustSignals';

const Home = () => {
  return (
    <div className="min-h-screen">
      <Hero />
      <TrustSignals />
      <ServicesPreview />
      <PartnerCarousel />
    </div>
  );
};

export default Home;